export function newlineToBreakEscape(val: string) {
    return val ? htmlEncode(val).replace(/(?:\r\n|\r|\n)/g, '<br>') : null;
}

export function htmlEncode(val: string) {
    return val.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
        return '&#'+i.charCodeAt(0)+';';
    });
}

export function convertToCssName(val: string) {
    return val.replace(/[^a-z0-9\-]/g, function (s) {
        var c = s.charCodeAt(0);
        if (c == 32) return '-';
        if (c >= 65 && c <= 90) return s.toLowerCase();

        //Replace norwegian characters: ���
        if (c == 198 || c == 230) return 'ae';
        if (c == 216 || c == 248) return 'o';
        if (c == 197 || c == 229) return 'aa';

        return '__' + ('000' + c.toString(16)).slice(-4);
    });
}

export function format(str: string, ...args: string[]) {
    return str.replace(/{(\d+)}/g, (match, number) => {
        return typeof args[number] != 'undefined'
            ? args[number]
            : match
            ;
    });
}

export function convertStringToNumber(input: string): number {
    if (input === "") {
        return 0;
    }
    let numberString = input.replace(/[^\d,]/g, ''); // Remove all non-digit characters except the comma
    const validDecimalNumberString = numberString.replace(',', '.');
    const number = parseFloat(validDecimalNumberString); // Convert the string to a number

    return number;
}